import React, { ReactNode } from 'react';
import { GoogleAnalyticsData } from '@/types/globals';

export interface AccordionItemProps {
	testId?: string;
	children: ReactNode;
	data?: GoogleAnalyticsData;
	className?: string;
}

const AccordionItem = (props: AccordionItemProps) => {
	const { children, testId = 'AccordionItem', data, className } = props;

	return (
		<li className={className} data-testid={testId} {...data}>
			{children}
		</li>
	);
};

export default AccordionItem;
